import { Link, Navigate, useLocation } from "react-router-dom";
import { LoaderCircle, ShieldAlert } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

const RoleNotice = ({ role }) => (
  <div className="mx-auto flex max-w-md flex-col items-center gap-3 px-4 py-20 text-center" data-testid="role-notice">
    <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-amber-50 text-amber-600"><ShieldAlert className="h-6 w-6" /></span>
    <p className="font-heading text-lg font-bold text-slate-900">{role === "admin" ? "Halaman khusus Admin RT" : "Halaman khusus akun warga"}</p>
    <p className="text-sm text-slate-500">Akun Anda tidak memiliki akses ke halaman ini.</p>
    <Button asChild className="rounded-xl bg-slate-900 hover:bg-slate-800"><Link to="/">Kembali ke beranda</Link></Button>
  </div>
);

export const ProtectedRoute = ({ role, children }) => {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) {
    return (
      <div className="flex min-h-[60vh] items-center justify-center text-slate-500" data-testid="auth-checking">
        <LoaderCircle className="mr-2 h-5 w-5 animate-spin text-emerald-600" /> Memeriksa sesi...
      </div>
    );
  }
  if (!user) return <Navigate to="/masuk" replace state={{ from: location.pathname }} />;
  if (role && user.role !== role) return <RoleNotice role={role} />;
  return children;
};
